import { Link } from 'react-router-dom'
import { useAuthContext } from '../context/AuthContext'

// Order matters — Help is always last
const publicSections = [
  { title: 'About', links: [
    { label: 'About Us', href: '/about' },
    { label: 'For Learners', href: '/for-learners' },
    { label: 'For Administrators', href: '/for-administrators' },
    { label: 'Features & Benefits', href: '/features' },
  ]},
  { title: 'Help', links: [
    { label: 'Contact Us', href: '/contact' },
    { label: 'Accessibility', href: '/accessibility' },
    { label: 'Privacy Policy', href: '/privacy' },
    { label: 'Site Index', href: '/sitemap' },
  ]},
]

const learnerSections = [
  { title: 'About', links: [
    { label: 'About Us', href: '/about' },
    { label: 'For Learners', href: '/for-learners' },
    { label: 'For Administrators', href: '/for-administrators' },
    { label: 'Features & Benefits', href: '/features' },
  ]},
  { title: 'Training', links: [
    { label: 'Dashboard', href: '/dashboard' },
    { label: 'Course Catalog', href: '/catalog' },
    { label: 'Transcript', href: '/transcript' },
    { label: 'Support', href: '/support' },
  ]},
  { title: 'Account', links: [
    { label: 'Profile Settings', href: '/account' },
    { label: 'Organization', href: '/account' },
    { label: 'Communications', href: '/account' },
    { label: 'Password', href: '/account' },
  ]},
  { title: 'Help', links: [
    { label: 'Contact Us', href: '/contact' },
    { label: 'Accessibility', href: '/accessibility' },
    { label: 'Privacy Policy', href: '/privacy' },
    { label: 'Site Index', href: '/sitemap' },
  ]},
]

const adminSections = [
  { title: 'About', links: [
    { label: 'About Us', href: '/about' },
    { label: 'For Learners', href: '/for-learners' },
    { label: 'For Administrators', href: '/for-administrators' },
    { label: 'Features & Benefits', href: '/features' },
  ]},
  { title: 'Training', links: [
    { label: 'Dashboard', href: '/dashboard' },
    { label: 'Course Catalog', href: '/catalog' },
    { label: 'Transcript', href: '/transcript' },
    { label: 'Support', href: '/support' },
  ]},
  { title: 'Admin', links: [
    { label: 'Dashboard', href: '/admin' },
    { label: 'Users', href: '/admin/users' },
    { label: 'Trainings', href: '/admin/trainings' },
    { label: 'Courses', href: '/admin/courses' },
    { label: 'Satisfaction', href: '/admin/satisfaction' },
    { label: 'Compliance', href: '/admin/compliance' },
  ]},
  { title: 'Account', links: [
    { label: 'Profile Settings', href: '/account' },
    { label: 'Organization', href: '/account' },
    { label: 'Communications', href: '/account' },
    { label: 'Password', href: '/account' },
  ]},
  { title: 'Help', links: [
    { label: 'Contact Us', href: '/contact' },
    { label: 'Accessibility', href: '/accessibility' },
    { label: 'Privacy Policy', href: '/privacy' },
    { label: 'Site Index', href: '/sitemap' },
  ]},
]

export default function Footer() {
  const { user, profile } = useAuthContext()
  const logoDestination = user ? '/dashboard' : '/'

  const sections = !user
    ? publicSections
    : profile?.role === 'admin'
      ? adminSections
      : learnerSections

  return (
    <footer className="bg-neutral-100 border-t border-neutral-200 print:hidden" role="contentinfo">
      <div className="mx-auto max-w-7xl px-4 py-10">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-12 items-start">
          {/* Link sections */}
          <div className="flex flex-wrap gap-10 sm:gap-14 flex-1">
            {sections.map((section) => (
              <div key={section.title}>
                <h4 className="text-neutral-900 font-bold text-sm mb-3">{section.title}</h4>
                <ul className="space-y-2">
                  {section.links.map((link) => (
                    <li key={link.href + link.label}>
                      <Link
                        to={link.href}
                        className="text-neutral-500 hover:text-primary text-sm transition-colors"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Right side — logo + branding */}
          <div className="shrink-0 text-right">
            <Link to={logoDestination} aria-label={user ? 'CETA Dashboard' : 'CETA Home'}>
              <img
                src="/logo.png"
                alt="CETA — College External Training Application"
                className="h-12 w-auto ml-auto mb-3"
              />
            </Link>
            <p className="text-base text-neutral-500">
              Built by{' '}
              <a
                href="https://metaphase.tech"
                target="_blank"
                rel="noopener noreferrer"
                className="js-axe-brand-exception font-bold text-[#E8642C] hover:underline"
              >
                MetaPhase
              </a>
            </p>
            <p className="text-sm text-neutral-500 mt-1">
              &copy; {new Date().getFullYear()} All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}
